export default "__VITE_ASSET__CVyZ9e4b__"